import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

const InProgressCustomerComplaint = Loadable(
  lazy(() => import("../InProgressCustomerComplaint"))
);
const CWRB = Loadable(lazy(() => import("../CWRB")));
const CWRBList = Loadable(lazy(() => import("../CWRBList")));
const CommunicationToRegBody = Loadable(
  lazy(() => import("../CommunicationToRegBody"))
);
const ChangeManagementYearData = Loadable(
  lazy(() => import("../ChangeManagementYearData"))
);
const CustomerComplaintYearData = Loadable(
  lazy(() => import("../CustomerComplaintYearData"))
);
const AdvisoryNotice = Loadable(lazy(() => import("../AdvisoryNotice")));
const AdvisoryNoticeList = Loadable(
  lazy(() => import("../AdvisoryNoticeList"))
);
const AmendmentsInTechnicalFile = Loadable(
  lazy(() => import("../AmendmentsInTechnicalFile"))
);
const AmendmentsInTechnicalFileYearData = Loadable(
  lazy(() => import("../AmendmentsInTechnicalFileYearData"))
);
const ChangeManagement = Loadable(lazy(() => import("../ChangeManagement")));
const CustomerComplaint = Loadable(lazy(() => import("../CustomerComplaint")));
const DesignModification = Loadable(
  lazy(() => import("../DesignModification"))
);
const DesignModificationYearData = Loadable(
  lazy(() => import("../DesignModificationYearData"))
);
const List = Loadable(lazy(() => import("../List")));
const YearList = Loadable(lazy(() => import("../YearList")));
const CWRBLog = Loadable(lazy(() => import("../CWRbLog")));

const CWRBRoutes = [
  {
    path: routeConstants.COMMUNICATION_WITH_REGULATORY_BODIES,
    children: [
      { path: "communication-with-regulatory-body", element: <CWRB /> },
      { path: "cwrb-list", element: <CWRBList /> },
      { path: "communicationToRegBody", element: <CommunicationToRegBody /> },
      { path: "list/:year", element: <List /> },
      { path: "year-list", element: <YearList /> },
      { path: "advisory-notice", element: <AdvisoryNotice /> },
      {
        path: "customer-complaint-year",
        element: <CustomerComplaintYearData />,
      },
      { path: "advisory-notice-list", element: <AdvisoryNoticeList /> },
      {
        path: "amendments-technical-file",
        element: <AmendmentsInTechnicalFile />,
      },
      {
        path: "amendments-technical-file-year",
        element: <AmendmentsInTechnicalFileYearData />,
      },
      { path: "change-management", element: <ChangeManagement /> },
      { path: "change-management-year", element: <ChangeManagementYearData /> },
      { path: "customer-complaint", element: <CustomerComplaint /> },
      { path: "design-modification", element: <DesignModification /> },
      {
        path: "design-modification-year",
        element: <DesignModificationYearData />,
      },
      { path: "cwrb-log", element: <CWRBLog /> },
      { path: "cwrb/:id", element: <InProgressCustomerComplaint /> },
    ],
  },
];

export default CWRBRoutes;
